import { render, staticRenderFns } from "./ProjectDocuments.vue?vue&type=template&id=e6ed26a8&scoped=true&"
import script from "./ProjectDocuments.vue?vue&type=script&lang=js&"
export * from "./ProjectDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDocuments.vue?vue&type=style&index=0&id=e6ed26a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ed26a8",
  null
  
)

export default component.exports